import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import { MainCanvas } from './styledComponents'
import { patientRoutes } from './routes'

export default function PatientRoutesHandler({ railOpen }) {
  return (
    <MainCanvas $railOpen={railOpen}>
      <Suspense
        fallback={
          <div style={{ display: 'flex', justifyContent: 'center', padding: 80 }}>
            <LoadingSpinner />
          </div>
        }
      >
        <Routes>
          {patientRoutes.map(({ path, name, Element }, idx) =>
            Element ? (
              path === '' ? (
                <Route key={idx} index name={name} element={<Element />} />
              ) : (
                <Route key={idx} path={path} name={name} element={<Element />} />
              )
            ) : null,
          )}
          <Route path="*" element={<Navigate to="/patient-home" replace />} />
        </Routes>
      </Suspense>
    </MainCanvas>
  )
}
